'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _hudlBase = require('hudl-base');

var _propTypes = require('../../shared/prop-types');

var _feedUserType = require('../../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _FollowUserButton = require('../../components/FollowUserButton');

var _FollowUserButton2 = _interopRequireDefault(_FollowUserButton);

var _Uniform = require('../Uniform');

var _feedUserUtil = require('../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _logValues = require('../../shared/logging/log-values');

require('./_mini-profile.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MiniProfileDisplay = function (_React$Component) {
  _inherits(MiniProfileDisplay, _React$Component);

  function MiniProfileDisplay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MiniProfileDisplay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MiniProfileDisplay.__proto__ || Object.getPrototypeOf(MiniProfileDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.fullProfileClicked = function (event) {
      var feedUser = _this.props.feedUser;
      var profileUrl = event.currentTarget.href;
      if (feedUser.isAthlete) {
        profileUrl = feedUser.athleteProfileUrl;
      } else if (feedUser.isTeam) {
        profileUrl = feedUser.teamProfileUrl;
      } else if (feedUser.isAuthor) {
        profileUrl = feedUser.authorProfileUrl;
      }

      if (profileUrl) {
        var defaultLogData = _defineProperty({
          FeedUser: feedUser.feedUserId.type + '-' + feedUser.feedUserId.relatedId,
          Func: 'Click',
          Op: 'Profile'
        }, _logValues.ORIGIN_KEY, _logValues.MINI_PROFILE_ORIGIN);

        new _hudlBase.UsageLogEvent({
          logger: 'Feed',
          data: _extends({}, defaultLogData, _this.props.logData)
        }).log();
        location.href = profileUrl;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MiniProfileDisplay, [{
    key: '_abbreviateNumber',
    value: function _abbreviateNumber(inputNumber) {
      var number = (0, _numeral2.default)(inputNumber);
      if (number.value() > 0) {
        return number.format('0a');
      }
      return 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          feedUser = _props.feedUser,
          currentUserId = _props.currentUserId,
          children = _props.children;

      var feedUserType = feedUser.feedUserId.type;
      // Do not show following stats for Hudl or team account
      var showFollowingStats = feedUserType !== _feedUserType2.default.Hudl && feedUserType !== _feedUserType2.default.Team;

      // Hide follow button if user not logged in or if viewing your own profile
      var showFollowButton = currentUserId && !(feedUserType === _feedUserType2.default.User && feedUser.feedUserId.relatedId === currentUserId);

      var userAvatar = void 0;
      var userName = void 0;
      var jersey = void 0;
      var position = void 0;
      if (feedUser.isAthlete) {
        var initials = _feedUserUtil2.default.getFeedUserInitials(feedUser.name);
        userAvatar = _react2.default.createElement(
          _Uniform.Link,
          { type: 'wrapper', href: feedUser.athleteProfileUrl },
          _react2.default.createElement(_Uniform.AvatarUser, {
            size: 'xlarge',
            initials: initials,
            imageUrl: feedUser.profileImageUrl.indexOf('thumb-user.svg') === -1 ? feedUser.profileImageUrl : null,
            className: 'uni-margin--half--right uni-margin--half--btm' })
        );
        userName = _react2.default.createElement(
          'div',
          { onClick: this.fullProfileClicked },
          _react2.default.createElement(
            _Uniform.Link,
            { type: 'wrapper', href: feedUser.athleteProfileUrl },
            _react2.default.createElement(
              _Uniform.Subhead,
              { className: 'fullname' },
              feedUser.name
            )
          )
        );
        jersey = _react2.default.createElement(
          'span',
          { className: 'jersey' },
          feedUser.jersey || '',
          ' '
        );
        position = _react2.default.createElement(
          'span',
          { className: 'position' },
          feedUser.positions || feedUser.positions
        );
      } else if (feedUser.isTeam) {
        userAvatar = _react2.default.createElement(
          _Uniform.Link,
          { type: 'wrapper', href: feedUser.teamProfileUrl },
          _react2.default.createElement(_Uniform.AvatarTeam, {
            size: 'xlarge',
            imageUrl: feedUser.profileImageUrl.indexOf('thumb-user.svg') === -1 ? feedUser.profileImageUrl : null,
            className: 'uni-margin--half--right uni-margin--half--btm' })
        );
        userName = _react2.default.createElement(
          'div',
          { onClick: this.fullProfileClicked },
          _react2.default.createElement(
            _Uniform.Link,
            { type: 'wrapper', href: feedUser.teamProfileUrl },
            _react2.default.createElement(
              _Uniform.Subhead,
              { className: 'fullname' },
              feedUser.name
            )
          )
        );
      } else if (feedUser.isAuthor) {
        userAvatar = _react2.default.createElement(_Uniform.AvatarOrg, {
          size: 'xlarge',
          imageUrl: feedUser.profileImageUrl.indexOf('thumb-user.svg') === -1 ? feedUser.profileImageUrl : null,
          className: 'uni-margin--half--right uni-margin--half--btm' });
        userName = _react2.default.createElement(
          'div',
          { onClick: this.fullProfileClicked },
          _react2.default.createElement(
            _Uniform.Link,
            { type: 'wrapper', href: feedUser.authorProfileUrl },
            _react2.default.createElement(
              _Uniform.Subhead,
              { className: 'fullname' },
              feedUser.name
            )
          )
        );
      } else {
        var _initials = _feedUserUtil2.default.getFeedUserInitials(feedUser.name);
        userAvatar = _react2.default.createElement(
          _Uniform.Link,
          { type: 'wrapper', href: feedUser.athleteProfileUrl },
          _react2.default.createElement(_Uniform.AvatarUser, {
            size: 'xlarge',
            initials: _initials,
            imageUrl: feedUser.profileImageUrl.indexOf('thumb-user.svg') === -1 ? feedUser.profileImageUrl : null,
            className: 'uni-margin--half--right uni-margin--half--btm' })
        );
        userName = _react2.default.createElement(
          'div',
          { onClick: this.fullProfileClicked },
          _react2.default.createElement(
            _Uniform.Link,
            { type: 'wrapper', href: feedUser.athleteProfileUrl },
            _react2.default.createElement(
              _Uniform.Subhead,
              { className: 'fullname' },
              feedUser.name
            )
          )
        );
      }

      var classLevel = void 0;
      if (feedUser.classLevel) {
        classLevel = _react2.default.createElement(
          'span',
          { className: 'class-level' },
          feedUser.classLevel,
          feedUser.school ? _react2.default.createElement(
            'span',
            null,
            ' at '
          ) : undefined
        );
      }

      var school = void 0;
      var city = feedUser.city && feedUser.city.trim();
      var state = feedUser.state && feedUser.state.trim();
      if (feedUser.school) {
        school = _react2.default.createElement(
          'span',
          { className: 'school' },
          feedUser.school,
          city && state ? _react2.default.createElement(
            'span',
            null,
            ' in '
          ) : undefined
        );
      }

      var cityState = void 0;
      if (city && state) {
        cityState = _react2.default.createElement(
          'span',
          { className: 'city-state' },
          city,
          ', ',
          state
        );
      }

      var highlightViews = void 0;
      if (feedUser.highlightViews) {
        var abbrHighlightViews = this._abbreviateNumber(feedUser.highlightViews);
        highlightViews = _react2.default.createElement(
          _Uniform.Text,
          { level: 'small', className: 'uni-margin--one--right' },
          _react2.default.createElement(
            'div',
            { className: 'stat' },
            feedUser.isAthlete ? _react2.default.createElement(
              'a',
              { href: feedUser.athleteProfileUrl },
              _react2.default.createElement(
                'span',
                { className: 'value' },
                abbrHighlightViews
              ),
              _react2.default.createElement(
                'span',
                { className: 'label' },
                feedUser.highlightViews === 1 ? ' View' : ' Views'
              )
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'value' },
                abbrHighlightViews
              ),
              _react2.default.createElement(
                'span',
                { className: 'label' },
                feedUser.highlightViews === 1 ? ' View' : ' Views'
              )
            )
          )
        );
      }

      var followStats = void 0;
      var followingStats = void 0;
      var abbrFollowersCount = this._abbreviateNumber(feedUser.followersCount);
      if (!feedUser.isTeam) {
        followStats = _react2.default.createElement(
          _Uniform.Text,
          { level: 'small', className: 'uni-margin--one--right' },
          _react2.default.createElement(
            'div',
            { className: 'stat followers' },
            _react2.default.createElement(
              'a',
              { href: feedUser.athleteProfileUrl },
              _react2.default.createElement(
                'span',
                { className: 'value' },
                abbrFollowersCount
              ),
              _react2.default.createElement(
                'span',
                { className: 'label' },
                feedUser.followersCount === 1 ? ' Follower' : ' Followers'
              )
            )
          )
        );

        if (showFollowingStats) {
          var abbrFriendsCount = this._abbreviateNumber(feedUser.friendsCount);
          followingStats = _react2.default.createElement(
            _Uniform.Text,
            { level: 'small' },
            _react2.default.createElement(
              'div',
              { className: 'stat' },
              _react2.default.createElement(
                'a',
                { href: feedUser.athleteProfileUrl },
                _react2.default.createElement(
                  'span',
                  { className: 'value' },
                  abbrFriendsCount
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'label' },
                  ' Following'
                )
              )
            )
          );
        }
      }

      var followButton = void 0;
      if (showFollowButton) {
        followButton = _react2.default.createElement(_FollowUserButton2.default, {
          logData: this.props.logData,
          feedUserId: this.props.feedUser.feedUserId
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'div',
            { className: 'feed-modal-close', onClick: this.props.onDialogClose },
            _react2.default.createElement(_Uniform.Icon, { type: 'uidismiss', size: 'large', color: 'subtle' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'user-container' },
            _react2.default.createElement(
              'div',
              { className: 'user-info' },
              _react2.default.createElement(
                'div',
                { className: 'user-avatar-container' },
                _react2.default.createElement(
                  'div',
                  { className: 'user-avatar', onClick: this.fullProfileClicked },
                  userAvatar
                ),
                followButton
              ),
              _react2.default.createElement(
                'div',
                { className: 'user-fields' },
                _react2.default.createElement(
                  'div',
                  { className: 'username' },
                  userName
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'user-location' },
                  _react2.default.createElement(
                    _Uniform.Text,
                    { level: 'small' },
                    classLevel,
                    school,
                    cityState
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'user-details' },
                  _react2.default.createElement(
                    _Uniform.Text,
                    { level: 'micro', color: 'nonessential' },
                    jersey,
                    position
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'user-stats' },
                  _react2.default.createElement(
                    'div',
                    { className: 'user-stats-container' },
                    highlightViews,
                    followStats,
                    followingStats
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'mini-profile-body feed-modal-content' },
          _react2.default.createElement(
            'div',
            { className: 'user-timeline' },
            children && children.length ? _react2.default.createElement(
              'ul',
              { className: 'feed-timeline mini-profile-timeline' },
              children
            ) : _react2.default.createElement(
              'div',
              { className: 'no-content' },
              _react2.default.createElement(
                _Uniform.Text,
                null,
                feedUser.name,
                ' hasn\u2019t made any posts.'
              )
            )
          )
        )
      );
    }
  }]);

  return MiniProfileDisplay;
}(_react2.default.Component);

MiniProfileDisplay.propTypes = {
  currentUserId: _react.PropTypes.string,
  feedUser: _propTypes.MiniProfileFeedUser.isRequired,
  onDialogClose: _react.PropTypes.func.isRequired,
  logData: _react.PropTypes.object,
  children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)])
};
exports.default = MiniProfileDisplay;